// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__W8EWl {
  display: flex;
  flex-direction: column;
  gap: 32px;
  font-family: SF Pro Rounded;
  font-size: 17px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;
  color: rgba(54, 69, 86, 0.6);
  padding: 20px;
}
@media screen and (max-width: 768px) {
  .styles_container__W8EWl {
    padding: 5px;
  }
}
.styles_container__W8EWl b {
  font-weight: 700;
  color: #000000;
}
.styles_container__W8EWl .styles_footnote__C7hzx {
  font-size: 13px;
  font-weight: 500;
  line-height: 15.51px;
}
.styles_container__W8EWl h1 {
  font-size: 30px;
  font-weight: 700;
  line-height: 35.8px;
  letter-spacing: -0.3px;
  color: #000000;
}
.styles_container__W8EWl a {
  color: #000000;
}
.styles_container__W8EWl .styles_grayText__CDisX {
  color: rgba(54, 69, 86, 0.6);
}
.styles_container__W8EWl .styles_tableWrapper__XJSUn {
  width: 100%;
  padding: 15px 0;
}
@media screen and (max-width: 768px) {
  .styles_container__W8EWl .styles_tableWrapper__XJSUn {
    overflow-y: scroll;
  }
}
.styles_container__W8EWl table {
  width: 100%;
  border-collapse: collapse;
}
@media screen and (max-width: 768px) {
  .styles_container__W8EWl table {
    width: 200%;
  }
}
.styles_container__W8EWl table tr {
  width: 100%;
}
.styles_container__W8EWl table th,
.styles_container__W8EWl table td {
  width: 25%;
  border: 1px solid #b9b9b9;
  background: transparent;
  padding: 10px 12px;
  vertical-align: top;
  font-size: 15px;
  font-weight: 500;
  line-height: 22px;
}
.styles_container__W8EWl table th {
  background: rgba(0, 0, 0, 0.0588235294);
  color: #000000;
}
.styles_container__W8EWl ul {
  padding-left: 27px;
}
.styles_container__W8EWl ul li::marker {
  color: rgba(54, 69, 86, 0.6);
}`, "",{"version":3,"sources":["webpack://./src/privacy-policy/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,4BAAA;EACA,aAAA;AACF;AACE;EAZF;IAaI,YAAA;EAEF;AACF;AAAE;EACE,gBAAA;EACA,cAAA;AAEJ;AACE;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;AACJ;AAEE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,cAAA;AAAJ;AAGE;EACE,cAAA;AADJ;AAIE;EACE,4BAAA;AAFJ;AAKE;EACE,WAAA;EAEA,eAAA;AAJJ;AAMI;EALF;IAMI,kBAAA;EAHJ;AACF;AAME;EACE,WAAA;EACA,yBAAA;AAJJ;AAMI;EAJF;IAKI,WAAA;EAHJ;AACF;AAKI;EACE,WAAA;AAHN;AAMI;;EAEE,UAAA;EACA,yBAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAJN;AAOI;EACE,uCAAA;EACA,cAAA;AALN;AASE;EACE,kBAAA;AAPJ;AAUM;EACE,4BAAA;AARR","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  font-family: SF Pro Rounded;\n  font-size: 17px;\n  font-weight: 400;\n  line-height: 24px;\n  text-align: left;\n  color: #36455699;\n  padding: 20px;\n\n  @media screen and (max-width: 768px) {\n    padding: 5px;\n  }\n\n  b {\n    font-weight: 700;\n    color: #000000;\n  }\n\n  .footnote {\n    font-size: 13px;\n    font-weight: 500;\n    line-height: 15.51px;\n  }\n\n  h1 {\n    font-size: 30px;\n    font-weight: 700;\n    line-height: 35.8px;\n    letter-spacing: -0.3px;\n    color: #000000;\n  }\n\n  a {\n    color: #000000;\n  }\n\n  .grayText {\n    color: #36455699;\n  }\n\n  .tableWrapper {\n    width: 100%;\n\n    padding: 15px 0;\n\n    @media screen and (max-width: 768px) {\n      overflow-y: scroll;\n    }\n  }\n\n  table {\n    width: 100%;\n    border-collapse: collapse;\n\n    @media screen and (max-width: 768px) {\n      width: 200%;\n    }\n    \n    tr {\n      width: 100%;\n    }\n\n    th,\n    td {\n      width: 25%;\n      border: 1px solid #b9b9b9;\n      background: transparent;\n      padding: 10px 12px;\n      vertical-align: top;\n      font-size: 15px;\n      font-weight: 500;\n      line-height: 22px;\n    }\n\n    th {\n      background: #0000000f;\n      color: #000000;\n    }\n  }\n\n  ul {\n    padding-left: 27px;\n\n    li {\n      &::marker {\n        color: #36455699;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__W8EWl`,
	"footnote": `styles_footnote__C7hzx`,
	"grayText": `styles_grayText__CDisX`,
	"tableWrapper": `styles_tableWrapper__XJSUn`
};
export default ___CSS_LOADER_EXPORT___;
